import { get, post, put, deleteRequest } from 'helpers/api';
import axios from 'axios';

const rootPath = '/docs/documents';

const newFolderPath = projectId => `/projects/${projectId}/document_folders`;
const folderPath = (projectId, folderId) => `/projects/${projectId}/document_folders/${folderId}`;
const projectDocPath = documentId => `/project_documents/${documentId}`;
const searchDocsPath = projectId => `/projects/${projectId}/document_and_folder_search`;

export function searchDocuments(projectId, marketing, nameCont, leaseSpaceId = null) {
  const params = { 'q[marketing]': marketing, 'q[name_cont]': nameCont };
  // A lease space's tab searches only its own tree; the server treats this as overriding marketing.
  if (leaseSpaceId) params['q[lease_space_id]'] = leaseSpaceId;
  return get(searchDocsPath(projectId), { params  });
}

export function fetchFolder(projectId, folderId) {
  return get(folderPath(projectId, folderId));
}

export function createDocument(projectId, projectType, marketing, docsDocument) {
  const type = projectType + 'Document';
  const contextParams = {
    projectId,
    marketing
  };

  const params = {
    contextType: type,
    contextParams,
    docsDocument
  };

  return post(rootPath, params);
}

export function createFolder(projectId, parentId, marketing = false) {
  const projectDocumentFolder = {
    parentId,
    marketing
  };

  const params = {
    projectId,
    projectDocumentFolder
  };

  return post(newFolderPath(projectId), params);
}

export function uploadDocument(projectId, projectType, marketing, folderId, file, headFolderId, leaseSpaceId = null) {
  const type = projectType + 'Document';

  // remove leading slash
  const path = file.path.replace(/^\/+/, '');

  const formData = new FormData();
  formData.append('docs_document[upload]', file);
  formData.append('docs_document[uploaded]', true);
  formData.append('context_type', type);
  formData.append(`context_params[project_id]`, projectId);
  formData.append(`context_params[marketing]`, marketing);
  formData.append(`context_params[folder_id]`, folderId);

  // A lease space's tab states which space it is showing so the server can refuse a folder_id from
  // another space's tree. Omitted -- not sent as `undefined`, which a form field turns into the
  // string 'undefined' -- from every deal tab, which the server reads as "no space".
  if (leaseSpaceId) formData.append(`context_params[lease_space_id]`, leaseSpaceId);

  if (path !== file.name) {
    formData.append('upload_options[full_path]', path);
  }

  if (headFolderId) {
    formData.append('upload_options[head_folder_id]', headFolderId);
  }

  return axios.post(rootPath, formData);
}

export function updateDocument(documentId, docsDocument) {
  return put(`${rootPath}/${documentId}`, { id: documentId, docsDocument });
}

export function deleteDocument(id) {
  const path = `${rootPath}/${id}`;
  return deleteRequest(path, { id });
}

export function deleteFolder(projectId, id) {
  const path = folderPath(projectId, id);
  return deleteRequest(path, { id });
}

export function updateFolder(projectId, id, projectDocumentFolder) {
  const path = folderPath(projectId, id);
  const params = {
    id,
    projectId,
    projectDocumentFolder
  };

  return put(path, params);
}

export function updateFolderParent(projectId, id, parentFolderId) {
  return updateFolder(projectId, id, { parentId: parentFolderId });
}

export function updateProjectDocumentParent(contextId, parentFolderId) {
  const path = projectDocPath(contextId);
  const params = { folderId: parentFolderId };

  return put(path, params);
}

export function updateProjectDocumentMarketing(marketing, contextId, folder, projectId) {
  const path = folder ? folderPath(projectId, contextId) : projectDocPath(contextId);
  const params = { marketing };

  return put(path, params);
}

export function addAttachmentToProject(marketing, projectId, taskId, attachmentId) {
  return put(`${rootPath}/add_attachment_to_project`, { marketing, projectId, taskId, attachmentId });
}

export function addDocumentToListingMedia(propertyId, documentId) {
  return put(`${rootPath}/add_document_to_listing_media`, { propertyId, documentId });
}
